import { Component, Input, OnInit } from '@angular/core';
import { UtilsService } from 'app/shared/utils.service';
import { GetUserQuery, RoleEnum } from 'app/API.service';
import { UserService } from 'app/shared/user.service';
import { BannerStateService } from 'app/shared/vendor-advertisement-banner/vendor-advertisement-banner.service';

@Component({
  selector: 'cygov-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false,
})
export class FooterComponent implements OnInit {
  @Input() showLegend = false;
  @Input() showFeatureLegend = false;
  isBnb: boolean = UtilsService.isBnB;
  lessThan = '<';
  isVendor: boolean = false;
  user: GetUserQuery;

  constructor(private userService: UserService) {}

  ngOnInit() {
    const role = this.userService.getCurrentRole();
    this.isVendor = role?.name?.toLowerCase() === RoleEnum.VENDOR.toLowerCase();
    this.userService
      .getCurrentUser()
      .then(user => {
        this.user = user;
      })
      .catch(error => {
        console.error('Failed to fetch user:', error);
      });
  }
}
